/**
 * 全局注册内置组件
 */
import CommonTips from './tips'

const components = [
    CommonTips,
]

function registerName(hyphenate, name, proxy) {
    if (proxy) {
        name = `${name}Proxy`
    }
    if (hyphenate) {
        return hyphenate(name)
    }
    return name
}

export default {
    install(Vue, { hyphenate } = {}) {
        components.forEach(component => {
            const { name } = component
            const { proxy } = component
            Vue.component(registerName(hyphenate, name), component)
            if (proxy) {
                Vue.component(registerName(hyphenate, name, true), proxy)
            }
        })
    },
}
